import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import BookingSearchResults from './BookingSearchResults';

export default injectIntl(withRouter(BookingSearchResults));
